import { memberApi } from '../config/axios-config';

export const getClaimsService = (tenantId, pageNumber, pageSize, fromDate, toDate, orderByDate, memberAccountHeader) => {

  return memberApi.get(
    `v4/my/claims?page=${pageNumber}&size=${pageSize}&memberClaimType=M&fromDate=${fromDate}&toDate=${toDate}&orderByDate=${orderByDate}`,
    {
      headers: {
        'tenant-id': tenantId,
        'member-account': memberAccountHeader
      }
    }
  );
};

export const getClaimDetailsService = (claimId, tenantId, memberAccountHeader) => {
  return memberApi.get(`v3/my/claims/${claimId}`, {
    headers: { 'tenant-id': tenantId,
               'member-account': memberAccountHeader }
  });
};

export const getSelfBenefitsExplanationService = (tenantId, claimNumber) => {
  return memberApi.post(
    'v2/my/docs/explanation-of-benefits',
    {
      claimNumber: claimNumber,
      fileFormat: 'pdf'
    },
    {
      headers: {
        'tenant-id': tenantId,
      }
    }
  );
};

export const getDependentBenefitsExplanationService = (tenantId, claimNumber, memberID) => {
  return memberApi.post(
    'v2/my/docs/explanation-of-benefits',
    {
      claimNumber: claimNumber,
      fileFormat: 'pdf',
      subscriberId:memberID
    },
    {
      headers: {
        'tenant-id': tenantId,
      }
    }
  );
};